<ngx-json-ld
  [json]='{
   "@context": "https://schema.org",
   "@type": "Organization",
   "name": "Bruiloft in je Broekzak",
   "legalName" : "Bruiloft in je Broekzak",
   "url": "https://bruiloftinjebroekzak.nl",
   "logo": "https://bruiloftinjebroekzak.nl/assets/images/logos/logo-bijb-small.png",
   "foundingDate": "2023",
   "founders": [
     {
     "@type": "Person",
      "name": "Rosalyn Sleurink"
     }
   ],
   "address": {
     "@type": "PostalAddress",
     "addressLocality": "Arnhem",
     "addressRegion": "Gelderland",
     "postalCode": "6828",
     "addressCountry": "NL"
   },
   "contactPoint": {
     "@type": "ContactPoint",
     "contactType": "customer support",
     "email": "info@bruiloftinjebroekzak.nl"
   },
   "sameAs": [
     "http://www.facebook.com/bruiloftinjebroekzak",
     "https://www.instagram.com/bruiloftinjebroekzak/",
     "https://www.linkedin.com/company/bruiloft-in-je-broekzak/"
   ]
 }'></ngx-json-ld>

<router-outlet></router-outlet>
